import { useContext, useState } from 'react'
import imageLoader from '../../../../utilities/imageLoader'
import BidWatchlistIcon from '../../../../elements/BidWatchlistIcon/BidWatchlistIcon'
import BidLabel from '../../../../elements/BidLabel/BidLabel'
import { ItemCardManger } from '@components/Cards/BidItem'
import BidStatus from '@components/Cards/BidItem/BidStatus'
import Quantity from '@components/Cards/BidItem/shared/Quantity'
import { getCardMiddleBorderColor } from '@components/Cards/BidItem/utilities/getColors'
import Link from 'next/link'
import { AuthContext } from '../../../../contexts/AuthContext'
import ImageWithBackup from '@components/ImageWithBackup'
import cn from 'classnames'

const CustomImage = ({}: any) => {
  const {
    item: {
      id,
      auctionId,
      title,
      imageUrl,
      pictures,
      itemClosed,
      initialQuantity,
      addedToWatchlist,
      condition,
      bidStatus,
    },
    itemHandler: { toggleWatchlist },
  } = useContext<any>(ItemCardManger)

  const { isAuthenticated } = useContext<any>(AuthContext)
  const [imgError, setImgError] = useState(false)
  const middleLine = getCardMiddleBorderColor(itemClosed, bidStatus)

  return (
    <>
      <Link
        href={`/${auctionId}/item-detail/${id}`}
        className={`relative h-full w-88 ${
          itemClosed ? 'bg-white' : ''
        } border-r-4 ${middleLine}`}
      >
        {(imageUrl || (pictures && pictures[0])) && (
          <ImageWithBackup
            loader={imageLoader}
            unoptimized
            alt={title}
            src={imageUrl || pictures[0]}
            fill
            className={cn(
              'object-cover',
              'object-center',
              `w-auto h-full mx-auto ${imgError ? 'invisible' : ''}`
            )}
            onError={() => setImgError(true)}
          />
        )}
        <BidStatus bidStatus={bidStatus} />
        <div className="absolute top-2.5 right-1.5">
          <BidLabel
            value={condition}
            theme="blue-dark"
            fontStyles="text-12 md:text-10"
          />
        </div>
        <Quantity quantity={initialQuantity} />
        {isAuthenticated && (
          <button
            type="button"
            className="absolute bottom-2.5 right-2.5 rounded-full"
            onClick={toggleWatchlist}
          >
            <BidWatchlistIcon
              id={id}
              watching={addedToWatchlist}
              size={28}
              hasCircleBackground={true}
            />
          </button>
        )}
      </Link>
    </>
  )
}

export default CustomImage
